import browser from '@openclassrooms/utils/browser';
import { renderElementWithStore } from 'Modules/store';

import NotificationBubbleMain from './NotificationBubbleMain';
import NotificationBubbleAlert from './NotificationBubbleAlert';

const { document } = browser;

function displayMainNotificationBubble() {
  const targetElements = document.querySelectorAll('.js-notifications-main');

  [...targetElements].forEach((element) => {
    renderElementWithStore(
      <NotificationBubbleMain className="popOut__notification  mainHeader__notification" />,
      element
    );
  });
}

function displayAlertsBubble() {
  const targetElements = document.querySelectorAll('.js-notifications-alerts');

  [...targetElements].forEach((element) => {
    renderElementWithStore(
      <NotificationBubbleAlert className="notificationsList__count" />,
      element
    );
  });
}

function display() {
  displayMainNotificationBubble();
  displayAlertsBubble();
}

export default display;
